import type { SVGProps } from 'react';

const SvgEmailAndSms = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="email-and-sms">
      <path d="M3.48 31.5h20.78A2.75 2.75 0 0 0 27 28.75v-5.3h-1.5v5.3A1.25 1.25 0 0 1 24.26 30H3.48a1.26 1.26 0 0 1-1.25-1.25V14.22h14.88v7a.75.75 0 0 0 .75.75h12.63a.76.76 0 0 0 .75-.75V1.25a.75.75 0 0 0-.75-.75H17.86a.74.74 0 0 0-.75.75v6.86H3.48a2.75 2.75 0 0 0-2.75 2.75v17.89a2.75 2.75 0 0 0 2.75 2.75M18.61 2h11.13v18.45H18.61ZM3.48 9.61h13.63v3.11H2.23v-1.86a1.26 1.26 0 0 1 1.25-1.25" />
      <path d="M5.21 17.65h8.75v1.5H5.21zM5.21 22.77h6.08v1.5H5.21zM22.56 17.65h3.22v1.5h-3.22z" />
    </g>
  </svg>
);

export default SvgEmailAndSms;
